module.exports = __webpack_public_path__ + "static/support-talk-f5984137712b27d3cab7dcd2b85304ea.svg";